
import Button from '../../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center animated-sky-bg"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/39465d1188971214703fabbf2fa7b7ef.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-blue-900/30 floating-overlay"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-full">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            <span className="block text-5xl md:text-7xl mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              Reason To Believe
            </span>
            <span className="block text-2xl md:text-4xl text-blue-200">
              信頼をカタチに。
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
            建物の課題に、最適な答えを。
          </p>
          
          <p className="text-lg text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed">
            私たちは提供するサービスの価値に理由を提示します。お客様の大切な資産を３つの事業領域からサポートし、信頼関係を大切に、未来を創造し続けます。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/services">
              <Button size="lg" className="bg-blue-600 hover:bg-blue-700">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-building-line"></i>
                </div>
                事業内容を見る
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-mail-line"></i>
                </div>
                お問い合わせ
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
